// TODO: Find way to import from tailwind.js
export default {
    xs: 640,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600,
}
